<template>
  <section>
    <b-container fluid>
      <b-row align-v="start" class="section-title">
        <b-col cols="12" lg="10" offset-lg="1" xl="8" offset-xl="2">
          <h2>Actualisez vos informations personnelles !</h2>
        </b-col>
      </b-row>
      <b-row align-v="center" class="section-content">
        <b-col
          cols="12"
          sm="10"
          offset-sm="1"
          md="8"
          offset-md="2"
          lg="6"
          offset-lg="3"
          xl="4"
          offset-xl="4"
        >
          <b-card class="mb-5">
            <b-form @submit.prevent="onSubmit">
              <b-form-group>
                <picture-input
                  id="pictureInput"
                  ref="pictureInput"
                  width="150"
                  height="150"
                  radius="50"
                  margin="16"
                  :zIndex="0"
                  size="5"
                  :hideChangeButton="true"
                  :plain="true"
                  :custom-strings="{
                    upload: 'Votre navigateur ne supporte pas l\'upload de fichier',
                    fileSize: 'La taille du fichier est trop grande',
                    fileType: 'Ce type de fichier n\'est pas supporté'
                  }"
                  :prefill="user.picture"
                  @change="onPictureChange"
                  class="mb-3"
                ></picture-input>
                <b-input-group class="mb-3">
                  <b-input-group-prepend is-text>
                    <i class="fa fa-user-circle fa-lg fa-fw"></i>
                  </b-input-group-prepend>
                  <b-form-input
                    id="usernameInput"
                    name="user.username"
                    type="text"
                    maxlength="50"
                    v-model.trim="user.username"
                    v-validate="'required'"
                    :state="!errors.has('user.username')"
                    aria-describedby="usernameLiveFeedback"
                    placeholder="Pseudo"
                    data-vv-as="&quot;Pseudo&quot;"
                    size="lg"
                    disabled
                  />
                </b-input-group>
                <b-input-group class="mb-3">
                  <b-input-group-prepend is-text>
                    <i class="fa fa-envelope-o fa-lg fa-fw"></i>
                  </b-input-group-prepend>
                  <b-form-input
                    id="emailInput"
                    name="user.email"
                    type="email"
                    maxlength="255"
                    v-model.trim="user.email"
                    v-validate="'required|email'"
                    :state="!errors.has('user.email')"
                    aria-describedby="emailLiveFeedback"
                    placeholder="Adresse e-mail"
                    data-vv-as="&quot;Adresse e-mail&quot;"
                    size="lg"
                    disabled
                  />
                </b-input-group>
                <b-form-text id="passwordChangeLink">
                  <a
                    href="#"
                    @click="hideNewPassField = !hideNewPassField"
                    :hidden="!hideNewPassField"
                  >Changez votre mot de passe?</a>
                </b-form-text>
                <div :hidden="hideNewPassField">
                  <b-input-group>
                    <b-input-group-prepend is-text>
                      <i class="fa fa-key fa-lg fa-fw"></i>
                    </b-input-group-prepend>
                    <b-form-input
                      id="passwordInput"
                      name="user.password"
                      :type="showPass ? 'text' : 'password'"
                      minlength="8"
                      maxlength="255"
                      v-model="user.password"
                      v-validate="'min:8'"
                      :state="!errors.has('user.password')"
                      aria-describedby="passwordLiveFeedback passwordLiveHelp"
                      placeholder="Nouveau mot de passe"
                      data-vv-as="&quot;Nouveau mot de passe&quot;"
                      size="lg"
                    />
                    <b-input-group-append>
                      <b-btn
                        variant="primary"
                        @click="showPass = !showPass"
                      >{{showPass ? 'Masquer' : 'Afficher' }}</b-btn>
                    </b-input-group-append>
                    <b-form-invalid-feedback
                      id="passwordLiveFeedback"
                      v-if="errors.has('user.password')"
                    >{{ errors.first('user.password') }}</b-form-invalid-feedback>
                  </b-input-group>
                  <b-form-text
                    id="passwordLiveHelp"
                  >Entrez un mot de passe contenant au minimum 8 caractères.</b-form-text>
                </div>
              </b-form-group>
              <b-form-group label="Informations personnelles:" class="mt-4">
                <b-input-group class="mb-3">
                  <b-input-group-prepend is-text>
                    <i class="fa fa-user-circle fa-lg fa-fw"></i>
                  </b-input-group-prepend>
                  <b-form-input
                    id="firstnameInput"
                    name="user.firstname"
                    type="text"
                    maxlength="50"
                    v-model.trim="user.firstname"
                    v-validate="'required'"
                    :state="!errors.has('user.firstname')"
                    aria-describedby="firstnameLiveFeedback"
                    placeholder="Prénom"
                    data-vv-as="&quot;Prénom&quot;"
                    size="lg"
                  />
                  <b-form-invalid-feedback
                    id="firstnameLiveFeedback"
                    v-if="errors.has('user.firstname')"
                  >{{ errors.first('user.firstname') }}</b-form-invalid-feedback>
                </b-input-group>
                <b-input-group class="mb-3">
                  <b-input-group-prepend is-text>
                    <i class="fa fa-user-circle fa-lg fa-fw"></i>
                  </b-input-group-prepend>
                  <b-form-input
                    id="lastnameInput"
                    name="user.lastname"
                    type="text"
                    maxlength="50"
                    v-model.trim="user.lastname"
                    v-validate="'required'"
                    :state="!errors.has('user.lastname')"
                    aria-describedby="lastnameLiveFeedback"
                    placeholder="Nom"
                    data-vv-as="&quot;Nom&quot;"
                    size="lg"
                  />
                  <b-form-invalid-feedback
                    id="lastnameLiveFeedback"
                    v-if="errors.has('user.lastname')"
                  >{{ errors.first('user.lastname') }}</b-form-invalid-feedback>
                </b-input-group>
                <b-input-group class="mb-3">
                  <b-input-group-prepend is-text>
                    <i class="fa fa-venus-mars fa-lg fa-fw"></i>
                  </b-input-group-prepend>
                  <b-form-select
                    id="genderInput"
                    name="user.gender"
                    v-model="user.gender"
                    size="lg"
                    :class="{ defined: user.gender }"
                  >
                    <option value="undefined" hidden disabled>Sexe</option>
                    <option value="male">Homme</option>
                    <option value="female">Femme</option>
                  </b-form-select>
                </b-input-group>
                <datepicker
                  id="birthdateInput"
                  name="user.birthdate"
                  v-model.trim="user.birthdate"
                  format="dd/MM/yyyy"
                  :monday-first="true"
                  :language="dpLocale"
                  :full-month-name="true"
                  placeholder="Date de naissance"
                  :bootstrap-styling="true"
                  :calendar-button="true"
                  :clear-button="true"
                  :disabled-dates="{ to: new Date(1900, 0, 1), from: new Date() }"
                  :initial-view="'year'"
                  calendar-button-icon="fa fa-calendar fa-lg fa-fw"
                  calendar-class="datepicker-cal"
                  input-class="form-control form-control-lg"
                  wrapper-class="mb-3"
                ></datepicker>
                <b-input-group>
                  <b-input-group-prepend is-text>
                    <i class="fa fa-home fa-lg fa-fw"></i>
                  </b-input-group-prepend>
                  <b-form-input
                    id="addressInput"
                    ref="addressInput"
                    type="text"
                    placeholder="Adresse"
                    autocomplete="off"
                    @change="onAddressChange"
                    size="lg"
                  />
                </b-input-group>
              </b-form-group>
              <b-input-group class="mb-3">
                <b-input-group-prepend is-text>
                  <i class="fa fa-phone fa-lg fa-fw"></i>
                </b-input-group-prepend>
                <b-form-input
                  id="phoneInput"
                  name="user.phone"
                  type="text"
                  maxlength="30"
                  v-model.trim="user.phone"
                  v-validate="{ regex: /^(?:(?:\+|00)33|0)\s*[1-9](?:[\s.-]*\d{2}){4}$/ }"
                  :state="!errors.has('user.phone')"
                  aria-describedby="phoneLiveFeedback"
                  placeholder="N° de téléphone"
                  data-vv-as="&quot;N° de téléphone&quot;"
                  size="lg"
                />
                <b-form-invalid-feedback
                  id="phoneLiveFeedback"
                  v-if="errors.has('user.phone')"
                >{{ errors.first('user.phone') }}</b-form-invalid-feedback>
              </b-input-group>
              <b-form-group label="Instruments pratiqués:" class="mt-4">
                <b-form-checkbox-group
                  id="instrumentsInputGroup"
                  name="user.instruments"
                  v-model="user.instruments"
                  :options="instrumentOptions"
                ></b-form-checkbox-group>
              </b-form-group>
              <b-form-group label="Détaillez votre profil:" class="mt-4">
                <b-input-group>
                  <b-form-textarea
                    id="presentationInput"
                    name="user.presentation"
                    rows="3"
                    max-rows="6"
                    :no-resize="true"
                    maxlength="5000"
                    v-model="user.presentation"
                    v-validate="'max:5000'"
                    :state="!errors.has('user.presentation')"
                    aria-describedby="presentationLiveFeedback"
                    placeholder="Présentez-vous ici!"
                    data-vv-as="&quot;Présentation&quot;"
                    size="lg"
                  ></b-form-textarea>
                  <b-form-invalid-feedback
                    id="presentationLiveFeedback"
                    v-if="errors.has('user.presentation')"
                  >{{ errors.first('user.presentation') }}</b-form-invalid-feedback>
                </b-input-group>
              </b-form-group>
              <b-button
                type="submit"
                variant="primary"
                size="lg"
                title="Mettre à jour le profil"
                :disabled="status.updating"
                class="m-2"
              >
                Mettre à jour
                <i class="fa fa-refresh fa-lg fa-fw"></i>
              </b-button>
              <i v-show="status.updating" class="loader fa fa-spinner fa-spin fa-2x"></i>
              <b-button
                v-if="loggedUser.role === 'admin' && loggedUser.id !== user.id"
                class="m-2"
                variant="danger"
                size="lg"
                title="Supprimer le profil"
                v-confirm="{
                          loader: true,
                          okText: 'Confirmer',
                          cancelText: 'Annuler',
                          ok: dialog => onDeleteUser(dialog),
                          message: 'Souhaitez-vous vraiment supprimer cet utilisateur?',
                          type: 'hard',
                          verification: 'ok',
                          verificationHelp: 'Entrez « ok » ci-dessous pour confirmer',
                        }"
              >
                Supprimer le profil
                <i class="fa fa-times fa-fw"></i>
              </b-button>
              <i v-show="status.deleting" class="loader fa fa-spinner fa-spin fa-2x"></i>
            </b-form>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { router } from "../helpers";
import { instrumentService } from "../services";
import PictureInput from "vue-picture-input";
import Datepicker from "vuejs-datepicker";
import { fr } from "vuejs-datepicker/dist/locale";

export default {
  name: "UserAccount",
  mounted: function() {
    if (this.$route.params.userId) {
      if (this.loggedUser.role !== "admin") {
        router.push("/settings");
      }
      this.get(this.$route.params.userId);
    } else {
      this.user = this.loggedUser;
    }
    this.addressInput = new google.maps.places.Autocomplete( // eslint-disable-line no-undef
      this.$refs.addressInput.$el,
      {
        types: ["address"],
        language: "fr",
        componentRestrictions: { country: "fr" }
      }
    );
    if (this.user.address && this.user.address.formatted_address) {
      this.$refs.addressInput.$el.value = this.user.address.formatted_address;
    }
    this.addressInput.addListener("place_changed", () => {
      this.user.address = this.addressInput.getPlace();
    });
    instrumentService.getAll().then(instruments => {
      this.instrumentOptions = instruments.map(instrument => {
        return {
          value: instrument.id,
          text: instrument.name
        };
      });
    });
  },
  data: function() {
    return {
      showPass: false,
      hideNewPassField: true,
      instrumentOptions: [],
      dpLocale: fr,
      user: {}
    };
  },
  components: {
    PictureInput,
    Datepicker
  },
  computed: {
    ...mapState({
      currentUser: state => state.users.current.user,
      loggedUser: state => state.account.user,
      status: state => state.account.status
    })
  },
  watch: {
    currentUser: function(newVal) {
      this.user = newVal;
      if (this.user.address && this.user.address.formatted_address) {
        this.$refs.addressInput.$el.value = this.user.address.formatted_address;
      }
      this.$forceUpdate();
    }
  },
  methods: {
    ...mapActions("users", ["get"]),
    ...mapActions("account", ["update", "destroy"]),
    onPictureChange(image) {
      if (image) {
        this.user.newPicture = image;
      }
    },
    onAddressChange() {
      if (this.user.address && this.user.address.formatted_address) {
        this.$refs.addressInput.$el.value = this.user.address.formatted_address;
      } else {
        this.$refs.addressInput.$el.value = null;
        this.user.address = undefined;
      }
    },
    onSubmit() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.update(this.user);
        }
      });
    },
    onDeleteUser(dialog) {
      this.destroy(this.user.id).then(() => dialog.close());
    }
  }
};
</script>

<style>
#picture-input .preview-container {
  border: 1px solid #32cd32;
}

#passwordChangeLink a,
.datepicker-cal {
  color: #2cb62c !important;
}

.datepicker-cal,
.datepicker-cal div {
  text-align: left;
}

.datepicker-cal .cell:not(.blank):not(.disabled).day:hover,
.datepicker-cal .cell:not(.blank):not(.disabled).month:hover,
.datepicker-cal .cell:not(.blank):not(.disabled).year:hover {
  border-color: #2cb62c !important;
}

.datepicker-cal .cell.selected {
  background: #2cb62c !important;
  color: #fff;
}

fieldset legend {
  color: #2cb62c;
  font-weight: bold;
}

#instrumentsInputGroup {
  background-color: #fff;
  border: 1px solid #32cd32 !important;
  border-radius: 0.3rem;
  color: #2cb62c;
  font-weight: bold;
  padding: 1rem;
  text-align: left;
}

#instrumentsInputGroup
  .custom-checkbox
  .custom-control-input:checked
  ~ .custom-control-label::before {
  background-color: #32cd32;
}

#instrumentsInputGroup .custom-control-inline {
  margin: 0.5rem 0;
  width: 33%;
  text-align: left;
}
</style>
